export default __webpack_public_path__ + "images/462df5cd68a32145cb9509b14c270b96-loading-icon.gif";